import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';

import { LinksService } from '../../services/links/links.service';
import { SessionsService } from '../../services/sessions/sessions.service';
import { ConfTypes, InvitationLink, Session } from '@sc/types';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';

@Component({
  selector: 'sc-invitation-link-menu',
  templateUrl: './invitation-link-menu.component.html',
  styleUrls: ['./invitation-link-menu.component.scss'],
})
export class InvitationLinkMenuComponent implements OnInit {
  @Input() defaultLocation: 'The Stage' | 'Backstage' = 'The Stage';
  @Input() session: Session;
  studioSession$ = this.sessionsService.studioSession$;
  links: Array<InvitationLink> = [];
  selectedLink: InvitationLink;

  constructor(
    private popoverController: PopoverController,
    private toastrService: ToastrService,
    private sessionsService: SessionsService,
    private linksService: LinksService
  ) {}

  ngOnInit() {
    this.setupLinks();
  }

  async copyLink() {
    if (this?.session?.confType === 'daily' || this.studioSession$.value?.confType === 'daily') {
      this.selectedLink = this.links[0];
    }

    try {
      await navigator.clipboard.writeText(this.selectedLink.url);
      await this.popoverController.dismiss();

      this.toastrService.success(`${this.selectedLink.location} Invitation Link`, `Successfully copied to clipboard`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });
    } catch (error) {
      await this.popoverController.dismiss();

      this.toastrService.error(`${this.selectedLink.location} Invitation Link`, `Failed to copy to clipboard`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });
    }
  }

  async setupLinks() {
    const { protocol, host } = window.location;
    const { showID, sessionID, sessionTitle, showTitle } = this.session || this.studioSession$.value;

    const longLinkOnStage = `${protocol}//${host}/studio/${showID}/session/${sessionID}/guest/anon`;
    const shortLinkOnStage: any = await this.linksService.getShortLink({
      url: longLinkOnStage,
      title: `On Stage Invitation to "${sessionTitle}" on ${showTitle}`,
      description: `You are Invited to a Recording Session, 🔴 Recorded on SquadCast`,
    });
    const parsedLinkOnStage = JSON.parse(shortLinkOnStage);

    const longLinkBackstage = `${protocol}//${host}/studio/${showID}/session/${sessionID}/location/backstage`;
    const shortLinkBackstage: any = await this.linksService.getShortLink({
      url: longLinkBackstage,
      title: `Backstage Invitation to "${sessionTitle}" on ${showTitle}`,
      description: `You are Invited to a Recording Session, 🔴 Recorded on SquadCast`,
    });
    const parsedLinkBackstage = JSON.parse(shortLinkBackstage);

    const stage: InvitationLink = {
      location: 'The Stage',
      url: parsedLinkOnStage.shortLink,
      description: 'Can record with other participants in the recording session.',
    };
    const backstage: InvitationLink = {
      location: 'Backstage',
      url: parsedLinkBackstage.shortLink,
      description: 'Can watch, listen, and chat with other participants in the recording session.',
    };

    if (this.session.confType === ConfTypes.DAILY) this.links = [stage];
    else this.links = [stage, backstage];

    if (this.session.confType === ConfTypes.DAILY) this.selectedLink = this.links[0];
    else this.selectedLink = this.links.find((link) => link.location === this.defaultLocation);

  }
}
